export default __webpack_public_path__ + "static/media/icon-telecharger.f69114c8.svg";